import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { FormEvent, useState } from "react";
import { cn } from "@/lib/utils";

export const SearchBar = ({
  size = "md",
  initial = "",
  className,
}: {
  size?: "md" | "lg";
  initial?: string;
  className?: string;
}) => {
  const [q, setQ] = useState(initial);
  const navigate = useNavigate();
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    navigate(`/zoeken?q=${encodeURIComponent(q.trim())}`);
  };
  return (
    <form
      onSubmit={onSubmit}
      className={cn(
        "flex w-full items-center gap-2 rounded-2xl border border-border bg-card shadow-card transition-smooth focus-within:border-primary focus-within:shadow-elegant",
        size === "lg" ? "p-2 pl-3 sm:pl-5" : "p-1.5 pl-3 sm:pl-4",
        className
      )}
    >
      <Search className={cn("shrink-0 text-muted-foreground", size === "lg" ? "h-5 w-5" : "h-4 w-4")} />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Zoek op meldcode, merk of productnaam"
        className={cn(
          "min-w-0 flex-1 bg-transparent outline-none placeholder:text-muted-foreground",
          size === "lg" ? "py-3 text-sm sm:text-base" : "text-sm py-2"
        )}
      />
      <button
        type="submit"
        className={cn(
          "shrink-0 rounded-xl bg-primary font-medium text-primary-foreground transition-smooth hover:bg-primary/90",
          size === "lg" ? "px-3 py-2.5 text-sm sm:px-6 sm:py-3 sm:text-base" : "px-3 py-2 text-sm sm:px-4"
        )}
      >
        Zoeken
      </button>
    </form>
  );
};
